/** Random caged shape */

import { GuitarLib } from '@tunasong/music-lib'
import type { NoteName, ScaleType } from '@tunasong/schemas'
import invariant from 'tiny-invariant'

export const getRandomCagedShape = (scaleType: ScaleType = 'major', maxFret = 24) => {
  // We need some frets to be able to play the shape
  invariant(maxFret >= 8, 'Max fret must be at least 8')

  /** Get a random CAGED shape */
  const cagedTemplate = GuitarLib.scalePatterns.CAGED

  const caged = ['C', 'A', 'G', 'E', 'D'] satisfies NoteName[]

  // Get the shape, and check that all the notes are in the fret range
  let shape: GuitarLib.GuitarPattern | null = null
  let fingeringsInRange = false
  let rootNote: NoteName | null = null
  let randomShapeIdx = -1
  do {
    // Choose C, A, G, E, D root note at random. This can be different from the shape
    rootNote = caged[Math.floor(Math.random() * 5)]
    // Choose C, A, G, E, D shape at random
    randomShapeIdx = Math.floor(Math.random() * cagedTemplate.shapes.length)

    const group = GuitarLib.generateScalePatternGroup({
      group: GuitarLib.scalePatterns.CAGED,
      rootScale: { root: rootNote, type: scaleType },
      startFret: 0,
      endFret: maxFret,
    })
    shape = group.shapes[randomShapeIdx]
    // Check that all shape fingerings are in the fret range
    fingeringsInRange = shape.fingerings.every(fingering => {
      const fret = fingering.fret
      return fret !== GuitarLib.MUTED_STRING && fret >= 0 && fret <= maxFret
    })
  } while (!fingeringsInRange)

  invariant(shape, 'Shape not found')

  return {
    shape,
    rootNote,
    shapeName: caged[randomShapeIdx],
  }
}
